var map = {
	"./12build_failed.png": "pb1A",
	"./12build_ok.png": "3PfD",
	"./12build_old.png": "JYdw",
	"./12build_uploading.png": "oWqt",
	"./approved.gif": "LMHm",
	"./approvedwithcomment.gif": "hVRu",
	"./bimstream_approved.png": "YJrV",
	"./bimstream_failed.png": "12E2",
	"./bimstream_old_version.png": "0GX4",
	"./bimstream_pending.png": "pUtk",
	"./clip.gif": "837G",
	"./clipBig.gif": "zn1e",
	"./comment.gif": "Zpyz",
	"./commentOldVersion.gif": "/fud",
	"./edit.gif": "9a71",
	"./edit_other_pc.gif": "Yt8C",
	"./favorite.gif": "zXMm",
	"./forapproval.gif": "TEIs",
	"./frozen.gif": "HZMS",
	"./locked.gif": "pmE5",
	"./marked.gif": "C71D",
	"./newDocument_EN.gif": "inF2",
	"./newDocument_NL.gif": "XwLR",
	"./newcomment_EN.gif": "enId",
	"./newcomment_NL.gif": "jeg/",
	"./newcomment_old.gif": "9Eh0",
	"./paperdocument.gif": "uK3r",
	"./preliminary.gif": "Ixkv",
	"./procedure.gif": "kcav",
	"./procedure_black.png": "3MKR",
	"./procedure_black_old.png": "P7Sc",
	"./procedure_green.png": "FIaR",
	"./procedure_green_old.png": "tByo",
	"./procedure_mixed.png": "XN/m",
	"./procedure_oldVersion.gif": "I7zW",
	"./procedure_red.png": "jbqJ",
	"./procedure_red_old.png": "WQpm",
	"./qrcode.png": "9lBY",
	"./qrcode_old_revoked.png": "wH7i",
	"./qrcode_oldversion.png": "A3DK",
	"./qrcode_revoked.png": "GUnH",
	"./rejected.gif": "Y3qz",
	"./search.png": "EFv6",
	"./snagstreamDrawing.png": "EuIL",
	"./snagstreamDrawingOldVersion.png": "vhY6",
	"./space.gif": "b3Bj",
	"./stamped.gif": "iV3X",
	"./stamped_oldversion.gif": "8E55",
	"./versionsascomment.gif": "ncjK",
	"./waitforrefresh.gif": "G5Lr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TBVL";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons ^\.\/.*$
// module id = TBVL
// module chunks = 1